import _extends from "/vercel/path0/node_modules/.pnpm/next@12.2.0_@babel+core@7.16.0_react-dom@17.0.2_react@17.0.2/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import React from "react";
var __jsx = React.createElement;
import { Tooltip as AntTooltip } from 'antd';
import { useTranslation } from 'react-i18next';
import IconExclamationMark from "../../assets/images/exclamation-mark.svg";
import { useBreakpoint } from "../../hooks";
import { TooltipsStyle, StyledTitle, StyledContent, StyledLink } from "./styled";

var Tooltip = props => {
  var children = props.children,
      className = props.className,
      img = props.img,
      overlayClassName = props.overlayClassName,
      placement = props.placement,
      title = props.title,
      tooltipTitle = props.tooltipTitle,
      tooltipTitleValue = props.tooltipTitleValue,
      link = props.link;

  var _useBreakpoint = useBreakpoint(),
      isMobile = _useBreakpoint.isMobile;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var showInfoIcon = !children;

  var TooltipContent = () => __jsx(React.Fragment, null, tooltipTitle && tooltipTitleValue && __jsx(StyledTitle, null, __jsx("span", null, tooltipTitle), __jsx("span", {
    className: "value"
  }, tooltipTitleValue)), __jsx(StyledContent, {
    opacity: tooltipTitle && tooltipTitleValue ? '0.6' : '0.8'
  }, title), link && __jsx(StyledLink, {
    href: link,
    target: "_blank",
    rel: "noopener noreferrer"
  }, t('learn more')));

  return __jsx(React.Fragment, null, __jsx(TooltipsStyle, null), __jsx(AntTooltip, _extends({
    trigger: "click"
  }, props, {
    title: TooltipContent,
    color: "#262C4B",
    className: "lon-tooltip ".concat(className !== null && className !== void 0 ? className : ''),
    overlayClassName: "lon-tooltip ".concat(overlayClassName, " ").concat(overlayClassName !== null && overlayClassName !== void 0 ? overlayClassName : ''),
    overlayStyle: {
      marginRight: '24px'
    },
    placement: isMobile ? 'bottom' : placement || 'right'
  }), children, showInfoIcon && __jsx("span", {
    className: "tooltip-wrap"
  }, __jsx("img", {
    src: img || IconExclamationMark,
    alt: ""
  }))));
};

export default Tooltip;